import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { IMG, EASE } from "@/lib/site";
import { CtaButton } from "./CtaButton";

const STEPS = [
  ["Hydrate", "Mobilee® targets the hyaluronic acid in your joint fluid."],
  ["Nourish", "Botanicals add antioxidant and soothing support."],
  ["Keep moving", "Taken daily, it becomes part of an active routine."],
];

export const Ritual = () => (
  <section id="ritual" className="bg-[#F2EDE4] py-24 sm:py-32" data-testid="ritual-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <div className="relative">
          <div className="aspect-[4/5] overflow-hidden rounded-t-full">
            <img src={IMG.dance} alt="Older couple dancing joyfully" className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 right-4 rotate-[-4deg] rounded-2xl bg-[#D96B43] px-5 py-4 font-serif text-2xl italic text-[#091D18] shadow-xl sm:right-10">
            the daily ritual
          </div>
        </div>
      </Reveal>
      <div>
        <Reveal>
          <Eyebrow>How it works</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#091D18] sm:text-5xl">
            Three quiet steps, <span className="font-serif italic font-normal text-[#D96B43]">every day.</span>
          </h2>
        </Reveal>
        <ol className="mt-12">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.12}>
              <li className="group flex gap-6 border-t border-[#091D18]/15 py-7" data-testid={`ritual-step-${i + 1}`}>
                <span className="w-16 shrink-0 font-display text-4xl sm:w-20 sm:text-5xl font-extrabold leading-none text-[#091D18]/15 transition-colors duration-500 group-hover:text-[#D96B43]">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-2xl font-semibold text-[#091D18]">{t}</h3>
                  <p className="mt-2 text-base text-[#091D18]/75">{d}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1, ease: EASE }}
          className="mt-6 inline-flex flex-wrap items-center gap-4 rounded-[2rem] bg-[#091D18] p-1.5 pl-6">
          <span className="text-sm text-[#F2EDE4]/80">Results vary by person.</span>
          <CtaButton testId="ritual-hoplink-button" placement="ritual">See the offer</CtaButton>
        </motion.div>
      </div>
    </div>
  </section>
);
